const SFLanguage = {
    pager_front: 'Front',
    pager_back: 'Back',
    terms_and_conditions_please_agree: 'Please agree to the <a href="{{URL}}" target="_blank">Terms and Conditions</a> and then proceed to customize your product.',
    add_an_image: 'Add an image',
    reset_button: 'Reset',
    large_preview_button: 'Preview your Product',
    save_button: 'Save Personalization',
    terms_and_conditions_not_returnable: 'Personalized products are not returnable.',
    terms_and_conditions_check_spelling: 'Please check your spelling and ensure that all text is correct.',
    terms_and_conditions_review: 'Please review your design carefully before saving.',
    terms_and_conditions_return_policy: 'Review our <a href="{{URL}}" target="_blank">Return Policy</a> if you have any questions or concerns.',
    button_agree: 'I Agree',
    drop_image_here_or_browse: 'Drop your image here, or browse',
    click_here_upload: 'Click here to upload your image',
    zoom_in_instructions_touch: 'Use the buttons below, or pinch to zoom in and out',
    zoom_in_instructions_desktop: 'Use the buttons below, or scroll the mouse wheel to zoom in and out',
    zoom_in_button: 'Zoom In',
    zoom_out_button: 'Zoom Out',
    please_wait: 'Please Wait...',
    error_saving_project: 'Error Saving Project',
    error_saving_project_message: 'Error "{{ERROR}}" saving project.  Please try again in a few minutes',
    text_preview_error: 'One or more text elements are too large to render. Please reduce the font size and try again.',
    ERROR_TOO_LARGE_TEXT: 'Text Too Large',
    server_error: 'Network Error'
};

export default SFLanguage;